import { ItemData } from 'core/models/Template'

export const CATALOGIZATOR_TITLE_KEY = 'catalogizator' as const
export const CATALOGIZATOR_MODULE_KEY = 'instancesCatalog/catalogizator' as const

export const CATALOGIZATOR_TABS = ['authorsList', 'artsList', 'downloadFromFile'] as const

export type CatalogizatorTab = typeof CATALOGIZATOR_TABS[number]

export const AUTHORS_CATALOG_TYPE = 'authors' as const
export const ARTS_CATALOG_TYPE = 'arts' as const

export const AUTHORS_CATALOG_CONFIG = {
    type: AUTHORS_CATALOG_TYPE,
    treeView: false,
    additionalData: {},
    fixedHeader: true,
    isExistRightToolbar: false,
    hideHeader: true,
} as const

export const ARTS_CATALOG_CONFIG = {
    type: ARTS_CATALOG_TYPE,
    treeView: false,
    additionalData: {},
    fixedHeader: true,
    isExistRightToolbar: false,
    hideHeader: true,
} as const

export type CatalogizatorSelectedItems = ItemData[]
